"use client";

import React, { useEffect, useState } from "react";
import { MapPin, Clock, Building2, ArrowRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: "quebec-main",
  city: "Québec",
  country: "Province de Québec",
  address: "Service mobile partout au Québec",
  top: "45%",
  left: "35%",
  timezone: "America/Toronto",
  isHQ: true
}, {
  id: "montreal-hub",
  city: "Montréal",
  country: "Grand Montréal",
  address: "Consultations privées sur rendez-vous",
  top: "55%",
  left: "28%",
  timezone: "America/Toronto",
  isHQ: false
}, {
  id: "laval-hub",
  city: "Laval",
  country: "Rive-Nord",
  address: "Expertise en dossiers complexes",
  top: "52%",
  left: "26%",
  timezone: "America/Toronto",
  isHQ: false
}, {
  id: "sherbrooke-hub",
  city: "Sherbrooke",
  country: "Estrie",
  address: "Solutions hypothécaires personnalisées",
  top: "58%",
  left: "38%",
  timezone: "America/Toronto",
  isHQ: false
}];
export default function NotreEmplacement() {
  const [mounted, setMounted] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());
  useEffect(() => {
    setMounted(true);
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);
  const getLocalTime = (timeZone: string) => {
    if (!mounted) return "--:--";
    try {
      return new Intl.DateTimeFormat("fr-CA", {
        timeStyle: "short",
        timeZone
      }).format(currentTime);
    } catch (e) {
      return "--:--";
    }
  };
  return <section data-section-id="224599" id="notre-emplacement" className="w-full py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight text-primary">
            Notre Présence au Québec
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl font-sans">
            Jenny Martel dessert l'ensemble de la province. Que vous soyez à Montréal, Québec ou en région, notre expertise en dossiers complexes vient à vous.
          </p>
        </div>

        <div className="relative w-full max-w-6xl mx-auto aspect-square md:aspect-[21/9] bg-primary rounded-md overflow-hidden shadow-xl border border-border">
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/quebec_map_navy_overlay.png)] bg-cover bg-center opacity-30 mix-blend-overlay pointer-events-none"></div>

          {}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none"></div>

          {}
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10" style={{
          top: loc.top,
          left: loc.left,
          transform: "translate(-50%, -50%)"
        }}>
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant="ghost" size="icon" className="relative h-auto w-auto p-0 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-primary group" aria-label={`Voir les détails pour ${loc.city}`}>
                    {}
                    <span className="absolute inline-flex h-8 w-8 rounded-md bg-secondary opacity-20 group-hover:opacity-40 animate-ping"></span>
                    {}
                    <span className="relative inline-flex rounded-md h-4 w-4 bg-secondary shadow-lg shadow-secondary/30 ring-2 ring-secondary/20 transition-transform group-hover:scale-110"></span>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-72 bg-card/95 backdrop-blur-md border-border shadow-2xl p-0 overflow-hidden rounded-md" sideOffset={8}>
                  <div className="p-4 border-b border-border bg-muted/50">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-default font-semibold text-lg flex items-center gap-2 text-primary">
                        {loc.city}
                        {loc.isHQ && <span className="text-[10px] uppercase tracking-widest bg-secondary/20 text-primary font-bold px-2 py-0.5 rounded-md font-sans">
                            Bureau Chef
                          </span>}
                      </h3>
                      <div className="flex items-center text-primary text-sm font-mono font-medium bg-secondary/10 px-2 py-1 rounded-md">
                        <Clock className="w-3 h-3 mr-1.5" />
                        <span suppressHydrationWarning>
                          {getLocalTime(loc.timezone)}
                        </span>
                      </div>
                    </div>
                    <p className="text-sm text-muted-foreground font-sans">
                      {loc.country}
                    </p>
                  </div>
                  <div className="p-4 space-y-3">
                    <div className="flex items-start gap-3 text-sm">
                      <MapPin className="w-4 h-4 text-secondary shrink-0 mt-0.5" />
                      <span className="text-foreground font-sans leading-tight">
                        {loc.address}
                      </span>
                    </div>
                    <div className="flex items-start gap-3 text-sm">
                      <Building2 className="w-4 h-4 text-secondary shrink-0 mt-0.5" />
                      <span className="text-foreground font-sans leading-tight">
                        Jenny Martel Hypothèques
                      </span>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </div>)}
        </div>

        <div className="mt-12 flex justify-center">
          <Button asChild size="lg" className="rounded-md px-10 bg-primary hover:bg-primary/90 text-primary-foreground shadow-md transition-all">
            <Link to="/ContactPage">
              Parler à une experte
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}